import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import { LARGE, LIGHT, SMALL, TOP } from './StatusBarConstants';
const StatusBarLabel = (props) => {
    var _a;
    const { label, size, className = '' } = props;
    if (!label.value) {
        return null;
    }
    const labelClasses = classNames('display-flex', 'ellipsis-1', 'flex-1-0', 'justify-content-center', (_a = label.color) !== null && _a !== void 0 ? _a : 'text-color-dark', {
        'width-0': label.alignment === TOP,
        'text-size-16': size === SMALL,
        'text-size-h3': size === LARGE,
        'text-bold': label.weight !== LIGHT,
    }, label.className);
    return (_jsx("div", Object.assign({ className: className }, { children: _jsx("span", Object.assign({ className: labelClasses }, { children: label.value })) })));
};
export default StatusBarLabel;
